var a = "-ms-", s = "-moz-", E = "-webkit-", e = "comm", m = "rule", r = "decl", M = "@import", R = "@keyframes", T = "@layer";
export {
  e as COMMENT,
  r as DECLARATION,
  M as IMPORT,
  R as KEYFRAMES,
  T as LAYER,
  s as MOZ,
  a as MS,
  m as RULESET,
  E as WEBKIT
};
//# sourceMappingURL=index.es94.js.map
